import type { ListLoopsFilters, ListRunsFilters } from './types';

export const COMMAND_CENTER_QUERY_KEYS = {
  summary: () => ['command-center', 'summary'] as const,
  catalog: () => ['command-center', 'catalog'] as const,
  n8nLive: () => ['command-center', 'n8n-live'] as const,
  heatmap: (windowHours: number) => ['command-center', 'heatmap', windowHours] as const,
  nodes: () => ['command-center', 'nodes'] as const,
  skills: () => ['command-center', 'skills'] as const,
  skillContent: (skillId: string) => ['command-center', 'skill-content', skillId] as const,
  // Deliberately not nested under nodes(): the enrollment code is never a query, and the registry
  // must be invalidatable on its own after an approve or revoke.
  nodeRegistry: () => ['command-center', 'node-registry'] as const,
  runs: (filters: ListRunsFilters) =>
    [
      'command-center',
      'runs',
      filters.status ?? '',
      filters.nodeId ?? '',
      filters.agentId ?? '',
      filters.from ?? '',
      filters.to ?? '',
      filters.limit ?? 0,
      filters.offset ?? 0,
    ] as const,
  runDetail: (runId: string) => ['command-center', 'run-detail', runId] as const,
  loops: (filters: ListLoopsFilters = {}) =>
    [
      'command-center',
      'loops',
      filters.state ?? '',
      filters.owner ?? '',
      filters.section ?? '',
      filters.limit ?? 0,
    ] as const,
  loop: (loopId: string) => ['command-center', 'loop', loopId] as const,
};
